import * as React from 'react';

import { ApexAccounts } from '../../../../roadmap/components/go/ApexAccounts';

export default function InvestmentAccountsScreen() {
    return <ApexAccounts />;
}
